const r = {
  "cdr-form-error": "cdr-form-error_13-5-2",
  "cdr-form-error__icon": "cdr-form-error__icon_13-5-2"
};
export {
  r as default
};
